module.exports = __webpack_public_path__ + "static/media/8.e8f26130.png";